import { NgClass } from '@angular/common';
import { Component, computed, input } from '@angular/core';

import type { DeviceData } from '../../models/devices';
import { computeDeviceDisplayStatus, DeviceDisplayStatus } from '../device-display-status';

const BADGE_LABEL: Record<DeviceDisplayStatus, string> = {
  archived: 'Archived',
  offline: 'Offline',
  online: 'Online',
  paused: 'Paused',
};

@Component({
  imports: [NgClass],
  selector: 'avs-device-status-badge',
  styleUrl: './device-status-badge.component.scss',
  templateUrl: './device-status-badge.component.html',
})
export class DeviceStatusBadgeComponent {
  device = input.required<DeviceData>();

  protected readonly BADGE_LABEL = BADGE_LABEL;

  protected status = computed(() => {
    const { deviceModelInformation, latestStreamingTimestamp, status, uptimeStatus } = this.device();

    return computeDeviceDisplayStatus({
      deviceTypeId: deviceModelInformation?.type?.id,
      latestStreamingTimestamp,
      status,
      uptimeStatus,
    });
  });
}
